import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MiniCartModule } from '@spartacus/cart/base/components/mini-cart';
import { CartQuickOrderFormModule, QuickOrderListModule } from '@spartacus/cart/quick-order/components';
import { FeaturesConfigModule, I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core';
import {
  DIALOG_TYPE,
  GenericLinkModule,
  IconModule,
  LayoutConfig,
  MediaModule,
  NavigationModule,
  OutletModule,
  SearchBoxModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { UserAccountService } from '@spartacus/user/account/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { SaveCartDialogComponent } from 'src/app/custom-cart/components/save-cart-dialog/save-cart-dialog.component';
import { CustomUserAccountService } from 'src/app/services/user-account.service';
import { CustomCxAddedToCartDialogComponent } from 'src/app/shared/custom-cx-added-to-cart-dialog/custom-cx-added-to-cart-dialog.component';
import { CustomCxLoginComponent } from './custom-cx-login/custom-cx-login.component';
import { CustomCxMiniCartComponent } from './custom-cx-mini-cart/custom-cx-mini-cart.component';
import { CustomCxNagivationUiComponent } from './custom-cx-nagivation-ui/custom-cx-nagivation-ui.component';
import { CustomCxNavigationComponent } from './custom-cx-navigation/custom-cx-navigation.component';
import { CustomNavigationUiComponent } from './custom-navigation-ui/custom-navigation-ui.component';
import { CustomSearchboxComponent } from './custom-searchbox/custom-searchbox.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';

export const CustomAddedToCartLayoutConfig: LayoutConfig = {
  launch: {
    MODAL_CART: {
      inlineRoot: true,
      component: CustomCxAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    SAVED_CART: {
      inline: true,
      component: SaveCartDialogComponent, // TODO: doesnt work, fix it
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};

@NgModule({
  declarations: [
    CustomCxNavigationComponent,
    CustomCxMiniCartComponent,
    CustomCxNagivationUiComponent,
    CustomCxLoginComponent,
    CustomNavigationUiComponent,
    CustomSearchboxComponent,
  ],
  imports: [
    CommonModule,
    MiniCartModule,
    I18nModule,
    IconModule,
    RouterModule,
    UrlModule,
    NavigationModule,
    GenericLinkModule,
    QuickOrderListModule,
    CartQuickOrderFormModule,
    SpinnerModule,
    CollapseModule,
    NgxBootstrapIconsModule,
    MediaModule,
    SearchBoxModule,
    FeaturesConfigModule,
    OutletModule,
  ],
  providers: [
    { provide: UserAccountService, useClass: CustomUserAccountService },
    [provideDefaultConfig(CustomAddedToCartLayoutConfig)],
  ],
})
export class ComponentsModule {}
